export abstract class CONSTANTS {
  static readonly DISMISS = 'dismiss-alert';
  static readonly ERROR = 'error-alert';
  static readonly SHOW_LOADER = 'show-loader';
  static readonly AUTH_HEADER = 'Authorization';
  static readonly REFRESH_TOKEN = 'refresh_token';
  static readonly ACCESS_TOKEN = 'refresh_token';
  static readonly ID_TOKEN = 'refresh_token';
  static readonly USERNAME = 'username';
  static readonly PASSWORD = 'password';
}
